// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportFileDatabaseMappingContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import { observable, action, computed } from 'mobx';

export default class ImportFileDatabaseMappingContent {
  @observable fromDatabaseName: string = null;
  @observable fromSchema: string = null;
  @observable serverType: string = null; // Haven't used
  @observable toDatabase: string = null; // Default APIs send 0000-0000...
  @observable toSchema: string = null; // Default APIs send 0000-0000...

  // APIs don't have
  @observable selectedToDatabaseName: string = null;
  @observable selectedToDatabaseNameId: string = null;
  @observable toSchemas: Array<any> = []; // Change, depend on selectedDatabaseNameTo
  @observable selectedToSchema: string = null;
  @observable selectedToSchemaId: string = null;

  @computed
  get fromDatabaseNameLabel() {
    return `[${this.serverType}] ${this.fromDatabaseName}`;
  }

  constructor(contentDatabaseMapping: any) {
    const { fromDatabaseName, fromSchema, serverType, toDatabase, toSchema } = contentDatabaseMapping;
    this.fromDatabaseName = fromDatabaseName;
    this.fromSchema = fromSchema;
    this.serverType = serverType;

    this.toDatabase = toDatabase;
    this.toSchema = toSchema;

    this.selectedToDatabaseName = null;
    this.selectedToDatabaseNameId = null;
    this.toSchemas = null;
    this.selectedToSchema = null;
    this.selectedToSchemaId = null;
  }

  /**
   * Set the selected ToDatabaseName
   * @param {string} id
   * @param {string} value
   */
  @action
  setSelectedToDatabaseName(id: string, value: string): void {
    if (this.selectedToDatabaseNameId != id) {
      this.selectedToDatabaseNameId = id;
      this.selectedToDatabaseName = value;
      this.toDatabase = id;

      // Reset to schema
      this.selectedToSchemaId = null;
      this.selectedToSchema = null;
    }
  }

  /**
   * Set the selected ToSchema
   * @param {string} id
   * @param {string} value
   */
  @action
  setSelectedToSchema(id: string, value: string): void {
    this.selectedToSchemaId = id;
    this.selectedToSchema = value;
    this.toSchema = id;
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ImportFileDatabaseMappingContent.js